<template>
  <div id="user-space-layer">
    <light-header></light-header>

    <div class="user-space-content">
      <div class="user-spact-info">
        <img :src="userInfo.isAuthed?authCompanyHeaderImgs[0]:authCompanyHeaderImgs[1]" class="user-img" alt="">
        <div class="user-name clearfix">
          <span>{{currentSpace.companyName}}</span>
          <img :src="userInfo.isAuthed?authIcons[0]:authIcons[1]" alt="">
        </div>
        <div class="company-admin clearfix">
          <p class="admin-title">企业管理员</p>
          <p class="admin-name">{{currentSpace.adminName}}</p>
          <p class="company-personal">企业成员</p>
          <p class="company-personal-num">{{currentSpace.members}}人</p>
        </div>
        <!-- <div class="company-meal">
          <p>10份</p>
          <p>企业套餐容量</p>
        </div>
        <div class="user-meal">
          <p>10份</p>
          <p>当前剩余合同发起数量</p>
        </div> -->
        <!-- <el-button type="primary" @click="toFlow" class="to-sign" style="background: #409eff; border-color: #409eff; color: white;">
          发起签约+</el-button> -->
          <a href="javascript:;" class="to-sign" @click="toFlow">发起签约+</a>
      </div>

      <div class="user-menu-content">
        <div class="user-menu">
          <el-menu
            :default-active="onRoutes"
            router
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            @select="handleSelect"
          >
            <el-submenu index="/company-space">
              <template slot="title">
                <span class="fitst-menu">合同管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/company-space/contracts?status=all">
                  <template>
                    <span class="menu-text" style="margin-left: 30px;">全部</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/company-space/contracts?status=pendTrial">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/pendTrial2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/pendTrial1-icon.png" alt="">
                    <span class="menu-text">待送审</span>
                    <span class="menu-num">{{currentSpace.pendTrial}}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/company-space/contracts?status=inApproval">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/inApproval2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/inApproval1-icon.png" alt="">
                    <span class="menu-text">送审审批中</span>
                    <span class="menu-num">{{currentSpace.inApproval}}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/company-space/contracts?status=approvalFailed">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/approvalFailed2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/approvalFailed1-icon.png" alt="">
                    <span class="menu-text">送审审批失败</span>
                    <span class="menu-num">{{currentSpace.approvalFailed}}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/company-space/contracts?status=waitSend">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/waitSend2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/waitSend1-icon.png" alt="">
                    <span class="menu-text">待发送</span>
                    <span class="menu-num">{{currentSpace.waitSend}}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/company-space/contracts?status=iSign">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/my2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/my1-icon.png" alt="">
                    <span class="menu-text">待我签署</span>
                    <span class="menu-num">{{currentSpace.iSign}}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/company-space/contracts?status=otherSign">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/sign2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/sign1-icon.png" alt="">
                    <span class="menu-text">待他签署</span>
                    <span class="menu-num">{{currentSpace.otherSign}}</span>
                  </template>
                </el-menu-item>
                 <el-menu-item index="/company-space/contracts?status=signingApproval">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/signingApproval2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/signingApproval1-icon.png" alt="">
                    <span class="menu-text">签署审批中</span>
                    <span class="menu-num">{{currentSpace.signingApproval}}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/company-space/contracts?status=signingApprovalFailed">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/signingApprovalFailed2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/signingApprovalFailed1-icon.png" alt="">
                    <span class="menu-text">签署审批失败</span>
                    <span class="menu-num">{{currentSpace.signingApprovalFailed}}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/company-space/contracts?status=finish">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/complete2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/complete1-icon.png" alt="">
                    <span class="menu-text">签署完成</span>
                    <span class="menu-num">{{currentSpace.finish}}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/company-space/contracts?status=expire">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/timeout2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/timeout1-icon.png" alt="">
                    <span class="menu-text">已过期</span>
                    <span class="menu-num">{{currentSpace.expire}}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/company-space/contracts?status=recall">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/recalled2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/recalled1-icon.png" alt="">
                    <span class="menu-text">撤回</span>
                    <span class="menu-num">{{currentSpace.recall}}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/company-space/contracts?status=returnd">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/returnd2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/returnd1-icon.png" alt="">
                    <span class="menu-text">退回</span>
                    <span class="menu-num">{{currentSpace.returnd}}</span>
                  </template>
                </el-menu-item>
                <!-- <el-menu-item index="/company-space/contracts?status=return">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/return2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/return1-icon.png" alt="">
                    <span class="menu-text">被退回</span>
                    <span class="menu-num">{{currentSpace.returnd}}</span>
                  </template>
                </el-menu-item> -->
                <el-menu-item index="/company-space/contracts?status=draft">
                  <template>
                    <img width="30" class="img1" src="../../assets/images/index/draft2-icon.png" alt="">
                    <img width="20" class="img2" src="../../assets/images/index/draft1-icon.png" alt="">
                    <span class="menu-text">草稿箱</span>
                    <span class="menu-num">{{currentSpace.draft}}</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item @click="companyConsoleHandle">
              <span class="fitst-menu" slot="title">签章管理</span>
            </el-menu-item>
            <!-- <el-menu-item v-if="!currentSpace.isAdmin" index="/company-space/signatures" class="parent">
              <span class="fitst-menu" slot="title">签章管理</span>
            </el-menu-item>
            <el-submenu v-if="currentSpace.isAdmin" index="/company-sian">
              <template slot="title">
                <span class="fitst-menu">签章管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/company-space/admin-signatures">
                  <template>
                    <span class="menu-text">印章管理</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/company-space/admin-authorize">
                  <template>
                    <span class="menu-text">授权管理</span>
                  </template>
                </el-menu-item>

              </el-menu-item-group>
            </el-submenu> -->
            <!-- <el-menu-item v-if="currentSpace.isAdmin" index="/company-space/personal-management" class="parent">
              <span class="fitst-menu" slot="title">人员管理</span>
            </el-menu-item> -->
          </el-menu>
        </div>

        <div class="user-main">
          <router-view></router-view>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import lightHeader from '../../components/lightHeader'
  import { mapState } from 'vuex'
  import { setTenantApi, contractCountApi, getCompanyListApi } from '@/api/home'
  import { getConsoleUrl } from '@/utils/auth'
  export default {
    components: {
      lightHeader
    },
    data() {
      return {
        authIcons: [
          require('../../assets/images/index/auth1-icon.png'),
          require('../../assets/images/index/auth2-icon.png')
        ],
        authCompanyHeaderImgs: [
          require('../../assets/images/index/company1-icon.png'),
          require('../../assets/images/index/company2-icon.png')
        ],
        currentCompany: {}
      }
    },
    computed: {
      onRoutes() {
        let path;
        if (this.$route.query.state) {
          path = this.$route.path+'?status='+this.$route.query.status
        } else {
          path = this.$route.path
        }
        return path
      },
      ...mapState([
        'userInfo',
        'companyList',
        'currentSpace'
      ])
    },
    mounted(){
      this.getCompanyListHandle()
    },
    methods: {

      // getContractCountHandle() {
      //   contractCountApi({
      //     companyId: this.currentSpace.companyId,
      //     nocache: new Date().getTime()
      //   }).then(res => {
      //     if (res.code !== 200) {
      //       this.$message({
      //         showClose: true,
      //         message: res.message,
      //         type: 'warning'
      //       });
      //     } else {

      //     }
      //   }).catch(err => {
      //     console.log(err)
      //   })
      // },

      getCompanyListHandle() {
        getCompanyListApi().then(res => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning'
            });
          } else {
            this.$store.commit('SET_COMPSNYL_LIST', res.data.companyInfos)
            this.companyList.forEach(company => {
              if (company.companyId == this.currentSpace.companyId) {
                this.$store.commit('SET_CURRENT_SPACE', company)
              }
            });
          }
        }).catch(err => {
          console.log(err)
        })
      },

      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      handleSelect(key, keyPath) {
        this.getCompanyListHandle()
      },
      toFlow() {
        this.$router.push({
          path: '/flow'
        })
      },
      companyConsoleHandle() {
        setTenantApi({
          tenantId: this.currentSpace.companyId
        }).then(res => {
          if (res.code != '0') {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning'
            });
          } else {
            window.location.href = getConsoleUrl() + '/seal/seal'
          }
          
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
</script>

<style>
  /* #user-space-layer .el-submenu.is-active .el-submenu__title{
    border-left: 3px solid #D95C59;
  }

  #user-space-layer .el-menu-item.is-active{
    border-left: 3px solid #D95C59;
  }

  #user-space-layer .el-menu-item-group .el-menu-item.is-active{
    border-left: none;
  } */
</style>

<style scoped>
  #user-space-layer {
    background: #f0f0f5;
  }

  .user-space-content {
    width: 1200px;
    margin: 30px auto 0;
  }

  .user-spact-info {
    width: 1200px;
    height: 164px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.13);
    position: relative;
  }

  .user-img {
    position: absolute;
    left: 30px;
    top: 26px;
  }

  .user-name {
    position: absolute;
    left: 99px;
    top: 38px;
    width: 700px;
  }

  .user-name span {
    float: left;
    color: #333333;
    font-size: 16px;
  }

  .user-name img {
    margin-left: 17px;
    margin-top: 2px;
  }

  .user-spact-info .card {
    position: absolute;
    left: 99px;
    top: 78px;
  }

  .user-spact-info .phone {
    position: absolute;
    left: 99px;
    top: 117px;
  }

  .user-spact-info .card,
  .user-spact-info .phone {
    font-size: 16px;
    line-height: 16px;
  }

  .user-spact-info .card span:nth-of-type(1),
  .user-spact-info .phone span:nth-of-type(1) {
    color: #999999;
    width: 65px;
    float: left;
  }

  .user-spact-info .card span:nth-of-type(2),
  .user-spact-info .phone span:nth-of-type(2) {
    color: #333333;
    margin-left: 25px;
  }

  .company-meal {
    position: absolute;
    left: 528px;
    top: 64px;
    width: 100px;
    text-align: center;
  }

  .company-meal p:first-child,
  .user-meal p:first-child {
    font-size: 26px;
    color: #333333;
    font-weight: 600;
  }

  .company-meal p:last-child,
  .user-meal p:last-child {
    font-size: 16px;
    color: #999999;
  }

  .user-meal {
    position: absolute;
    left: 691px;
    top: 64px;
    text-align: center;
    width: 160px;
  }

  .to-sign {
    position: absolute;
    right: 79px;
    top: 64px;
    width:100px;
    height:32px;
    background:linear-gradient(0deg,rgba(59,178,253,1) 0%,rgba(15,217,242,1) 99%);
    box-shadow:0px 1px 9px 0px rgba(0, 0, 0, 0.17);
    border-radius:10px;
    text-align: center;
    display: block;
    line-height: 33px;
    color: #ffffff;
    font-size: 16px;
  }

  .user-menu-content {
    width: 1200px;
    margin: 22px auto 0;
    display: flex;
    justify-content: space-between;
  }

  .user-menu {
    width: 230px;
    min-height: calc(100vh - 287px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.13);
  }

  .user-main {
    width: 948px;
    min-height: calc(100vh - 287px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.08);
    overflow-y: auto;
  }

  .menu-text{
    font-size: 14px;
    margin-left: 10px;
    color: #999999;
  }

  .menu-num{
    font-size: 14px;
    margin-left: 10px;
    color: #999999;
  }

  .fitst-menu{
    font-size: 16px;
    color: #666666;
  }

  .img1{
    display: none;
    margin-left: -5px;
  }

  .el-menu-item:hover, .el-menu-item:focus{
    background: #ffffff;
  }

  .el-menu-item:hover .menu-text, .el-menu-item:focus .menu-text{
    color: #333333;
  }

  .el-menu-item:focus .menu-num, .el-menu-item:hover .menu-num{
    color: #276EE8;
  }

  .el-menu-item:hover .img1, .el-menu-item:focus .img1, .el-menu-item:active .img1, .el-menu-item:visited .img1{
    display: inline-block;
  }

  .el-menu-item:hover .img2, .el-menu-item:focus .img2, .el-menu-item:active .img2, .el-menu-item:visited .img2{
    display: none;
  }

  .parent:hover, .parent:focus, .is-active{
    /* background: rgba(217,92,89, .1); */
  }

  .is-active .el-menu-item {
    background: #ffffff;
  }

  .is-active .is-active .menu-text{
    color: #333333;
  }

  .is-active .is-active .img1 {
    display: inline-block;
  }

  .is-active .is-active .img2 {
    display: none;
  }

  .company-admin{
    position: absolute;
    left: 98px;
    top: 100px;
    font-size: 16px;
  }

  .company-admin p{
    float: left;
  }

  .admin-title{
    color: #999999;
    margin-right: 27px;
  }

  .admin-name{
    color: #333333;
    margin-right: 15px;
    height: 20px;
    line-height: 22px;
    background: url('../../assets/images/index/admin-icon.png') no-repeat right top;
    padding-right: 25px;
  }

  .company-personal{
    color: #999999;
    margin-right: 24px;
  }

  .company-personal-num{
    font-weight: 600;
  }

</style>
